import { forwardRef } from "react";
import { Icon } from "@/components/ui/icon";
import { ScrollArea } from "@/components/ui/scroll-area";
import { OttoMessage, Message } from "./OttoMessage";

interface OttoMessageListProps {
  messages: Message[];
  isLoading: boolean;
  isLoadingHistory: boolean;
}

export const OttoMessageList = forwardRef<HTMLDivElement, OttoMessageListProps>(
  ({ messages, isLoading, isLoadingHistory }, ref) => {
    if (isLoadingHistory) {
      return (
        <div className="flex-1 flex items-center justify-center">
          <Icon name="loader" size={32} className="animate-spin text-muted-foreground" />
        </div>
      );
    }

    return (
      <ScrollArea className="flex-1 p-4" ref={ref}>
        <div className="space-y-4">
          {messages.map((message) => (
            <OttoMessage key={message.id} message={message} />
          ))}
          {isLoading && (
            <div className="flex justify-start">
              <div className="bg-muted rounded-lg px-3 py-2">
                <Icon name="loader" size={16} className="animate-spin text-muted-foreground" />
              </div>
            </div>
          )}
        </div>
      </ScrollArea>
    );
  }
);

OttoMessageList.displayName = "OttoMessageList";
